import { mainCities } from '../constants/arrays'

export const required = value => (value || typeof value === 'number' ? false : true)

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? true
    : false

export const minLength = min => value =>
  value && value.length < min ? true : false

export const minLength8 = minLength(8)

export const isMainCity = value => mainCities.includes(value) ? null : 'Оберіть місто з випадаючого списку'



// WEBPACK FOOTER //
// ./src/services/validations.js